import { createAsyncThunk } from '@reduxjs/toolkit'
import { setError } from '../../ui/error/actions'
import {
  FixtureCheckRequestBody,
  PlayerCheckRequestBody,
  PlayersCheckRequestBody,
  checkFixtureRequest,
  checkGeniusStatusRequest,
  checkPlayerRequest,
  checkPlayersRequest,
  getGeniusFixtureRosterRequest
} from './api'
import {
  addFetchingPlayerIds,
  removeFetchingPlayerIds,
  setRoster,
  updateFixtureFromAPIResponse,
  updateGeniusStatus,
  updatePlayersFromAPIResponse
} from './slice'

export const checkGeniusStatus = createAsyncThunk(
  'genius status',
  async (_, { dispatch }) => {
    try {
      const response = await checkGeniusStatusRequest()
      dispatch(updateGeniusStatus(response.data as any))

      // Refresh roster //
      dispatch(getGeniusFixtureRoster())
    } catch (error: any) {
      dispatch(
        setError({
          message:
            error.response && error.response.data && error.response.data.detail
              ? error.response.data.detail
              : `Failed to resolve genius fixture. Request failed. Check log for more detail.`
        })
      )
    }
  }
)

export const checkGeniusFixture = createAsyncThunk(
  'checkFixture',
  async (data: FixtureCheckRequestBody, { dispatch }) => {
    try {
      const response = await checkFixtureRequest(data)
      dispatch(updateFixtureFromAPIResponse(response.data as any))

      // Refresh roster //
      dispatch(getGeniusFixtureRoster())
    } catch (error: any) {
      dispatch(
        setError({
          message:
            error.response && error.response.data && error.response.data.detail
              ? error.response.data.detail
              : `Failed to resolve genius fixture. Request failed. Check log for more detail.`
        })
      )
    }
  }
)

export const checkGeniusPlayer = createAsyncThunk(
  'checkPlayer',
  async (data: PlayerCheckRequestBody, { dispatch }) => {
    dispatch(addFetchingPlayerIds([data.playerId]))
    try {
      const response = await checkPlayerRequest(data)
      dispatch(updatePlayersFromAPIResponse(response.data as any))
      dispatch(removeFetchingPlayerIds([data.playerId]))

      // Refresh roster //
      dispatch(getGeniusFixtureRoster())
    } catch (error: any) {
      dispatch(
        setError({
          message:
            error.response && error.response.data && error.response.data.detail
              ? error.response.data.detail
              : `Failed to resolve genius player. Request failed. Check log for more detail.`
        })
      )
      dispatch(removeFetchingPlayerIds([data.playerId]))
    }
  }
)

export const checkGeniusPlayers = createAsyncThunk(
  'checkPlayers',
  async (data: PlayersCheckRequestBody, { dispatch }) => {
    // Add fetching player ids
    const playerIds = data.map((p) => p.playerId)
    dispatch(addFetchingPlayerIds(playerIds))
    try {
      const response = await checkPlayersRequest(data)
      dispatch(updatePlayersFromAPIResponse(response.data as any))
      dispatch(removeFetchingPlayerIds(playerIds))

      // Refresh roster //
      dispatch(getGeniusFixtureRoster())
    } catch (error: any) {
      dispatch(
        setError({
          message:
            error.response && error.response.data && error.response.data.detail
              ? error.response.data.detail
              : `Failed to resolve genius player. Request failed. Check log for more detail.`
        })
      )
      dispatch(removeFetchingPlayerIds(playerIds))
    }
  }
)

// Get genius fixture roster //
export const getGeniusFixtureRoster = createAsyncThunk(
  'getGeniusFixtureRoster',
  async (_, { dispatch }) => {
    try {
      const response = await getGeniusFixtureRosterRequest()
      dispatch(setRoster(response.data as any))
    } catch (error: any) {
      dispatch(
        setError({
          message:
            error.response && error.response.data && error.response.data.detail
              ? error.response.data.detail
              : `Failed to get genius fixture roster. Request failed. Check log for more detail.`
        })
      )
    }
  }
)
